.event-edit-modal {
	padding: 10px 20px;
	height: 100%;
	box-sizing: border-box;
	max-width: 300px;
}
